import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { copyToClipboard } from '../../../utils';
import { useSelector } from 'react-redux';
import {
  CSR_SHARE_CART_LINK_FLOW_PARAM,
  CSR_SHARE_CART_LINK_FLOW_PARAM_REGISTERED_USERS_VALUE,
  CSR_SHARE_CART_LINK_PRESELECTED_DCN_PARAM,
  CSR_SHARE_CART_LINK_STOREID_PARAM,
  CSR_SHARE_CART_LINK_STORE_LOCATION_ID_PARAM,
  iconSize
} from '../constants';
import { AlloyButton, AlloyIcon } from 'cat-ecommerce-alloy';

const ShareCartButtonForRegisteredUser = () => {
  const [t] = useTranslation();
  const [isCopying, setIsCopying] = useState(false);
  const storeId = useSelector(s => s.common?.storeId);
  const storeLocationId = useSelector(s => s.common?.selectedStore);
  const dealerCode = useSelector(s => s.dealer?.dealerCode);

  const handleCopyToClipboard = () => {
    const currentUrl = new URL(
      window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname
    );
    currentUrl.searchParams.set(
      CSR_SHARE_CART_LINK_PRESELECTED_DCN_PARAM,
      dealerCode
    );
    currentUrl.searchParams.set(
      CSR_SHARE_CART_LINK_STORE_LOCATION_ID_PARAM,
      storeLocationId
    );
    currentUrl.searchParams.set(CSR_SHARE_CART_LINK_STOREID_PARAM, storeId);
    currentUrl.searchParams.set(
      CSR_SHARE_CART_LINK_FLOW_PARAM,
      CSR_SHARE_CART_LINK_FLOW_PARAM_REGISTERED_USERS_VALUE
    );
    copyToClipboard(currentUrl.href);

    setIsCopying(true);
    setTimeout(() => {
      setIsCopying(false);
    }, 3000);
  };

  const shareCartTitle = t('SHARE_CART');
  const downloadLabel = t('SHARE');
  const buttonText = !isCopying ? shareCartTitle : t('LINK_COPIED');

  useEffect(() => {
    document.addEventListener('copy', handleCopyToClipboard);
    return () => document.removeEventListener('copy', handleCopyToClipboard);
  }, []);

  return (
    <AlloyButton
      aria-label={shareCartTitle}
      className="d-inline-flex align-items-center mt-2 mt-md-0 mb-4 mb-md-0 p-0 mx-5"
      buttonType="ghost"
      onClick={handleCopyToClipboard}
      disabled={isCopying}
    >
      <AlloyIcon
        title={downloadLabel}
        icon="icon-share"
        height={iconSize}
        width={iconSize}
        className="d-none d-md-inline-block me-2"
      />
      <div
        className="u-fs--16 ps-md-1 ps-lg-0"
        data-testid="share-button-registered-user-text"
      >
        {buttonText}
      </div>
    </AlloyButton>
  );
};

export default ShareCartButtonForRegisteredUser;
